import {Button} from 'primereact/button';
import {InputText} from 'primereact/inputtext';
import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {LoginService} from '../../login/LoginService';
import {Password} from 'primereact/password';
import {AppStorage} from '../../../service/UserStorage';
import {Sign, useSign} from '../../../shared/component/Sign';


type UsbTokenProps = {
  setDisplayChangePassDone?: (display: boolean) => void;
};

export default function UsbToken({setDisplayChangePassDone}: UsbTokenProps) {
  const [submitted, setSubmitted] = useState(false);
  const [value, setValue] = useState({
    taxCode: '',
    account: '',
    newPassword: '',
    confirmPassword: '',
  });
  const {renderSign, sign} = useSign({onComplete: null});
  const [error, setError] = useState({
    taxCode: '',
    account: '',
    newPassword: '',
    confirmPassword: '',
  });

  const validateTaxCode = (value) => {
    let patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]$/;
    if (value.length > 10) {
      patt = /^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9][-][0-9][0-9][0-9]$/;
    }
    if (value === '') return true;
    if (patt.test(value) === false) {
      return false;
    }
    const number = Number(value.charAt(0)) * 31 + Number(value.charAt(1)) * 29 + Number(value.charAt(2)) * 23 + Number(value.charAt(3)) * 19 + Number(value.charAt(4)) * 17 + Number(value.charAt(5)) * 13 + Number(value.charAt(6)) * 7 + Number(value.charAt(7)) * 5 + Number(value.charAt(8)) * 3;

    return 10 - (number % 11) === Number(value.charAt(9));
  };
  useEffect(() => {
    document.documentElement.style.fontSize = '14px';
    if (AppStorage.get('tenantName')) {
      setValue({...value, taxCode: AppStorage.get('tenantName')});
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const validate = () => {
    let valid = true;
    for (const key in value) {
      if (!value[key]) {
        setError((err) => ({...err, [key]: 'không được để trống'}));
        valid = false;
      } else {
        setError((err) => ({...err, [key]: ''}));
      }
      if (key === 'taxCode' && value[key] && !validateTaxCode(value.taxCode)) {
        setError((err) => ({...err, [key]: ' không đúng định dạng'}));
        valid = false;
      }
      if (key === 'email' && value[key] && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value[key])) {
        setError((err) => ({...err, [key]: ' không đúng định dạng'}));
        valid = false;
      }
      if (key === 'confirmPassword' && value[key] !== value['newPassword']) {
        setError((err) => ({...err, [key]: 'Mật khẩu nhập lại không đúng'}));
        valid = false;
      }
    }

    return valid;
  };

  const handleChange = (event) => {
    const {name, value} = event.target;
    setValue((val) => ({
      ...val,
      [name]: value,
    }));
  };
  const handleSubmit = (event) => {
    if (!submitted && validate()) {
      Sign({
        "CommandName": "ChangePassword",
        "ResetPasswordByToken": {
         ...value
        }
      }).then(() => {
        setSubmitted(true);
        setSubmitted(false);
        setDisplayChangePassDone(true);
      });
    }
    event.preventDefault();
  };
  return (
    <>
      <p className="text-center text-lg mb-4">Vui lòng cắm USB Token và cài Plugin ký để lấy lại mật khẩu </p>
      <form onSubmit={handleSubmit} className="p-fluid p-2">
        <div className="mb-3">
          <label htmlFor="taxCode" className="block text-900 font-medium mb-2">
            Mã số thuế
            <span className="required">*</span>
          </label>
          <InputText id="taxCode" name="taxCode" type="text" value={value.taxCode} onChange={(e) => handleChange(e)} />
          {error.taxCode && <small className="p-error">{`Mã số thuế ${error.taxCode}`}</small>}
        </div>
        <div className="mb-3">
          <label htmlFor="account" className="block text-900 font-medium mb-2">
            Tên đăng nhập
            <span className="required">*</span>
          </label>
          <InputText maxLength={50} id="account" name="account" type="text" value={value.account} onChange={(e) => handleChange(e)} />
          {error.account && <small className="p-error">{`Tên đăng nhập ${error.account}`}</small>}
        </div>
        <div className="mb-3 flex justify-content-between gap-5">
          <div>
            <label htmlFor="newPassword" className="block text-900 font-medium mb-2">
              Mật khẩu mới
              <span className="required">*</span>
            </label>
            <Password toggleMask={true} name="newPassword" id="newPassword" type="text" value={value.newPassword} onChange={(e) => handleChange(e)} />
            {error.newPassword && <small className="p-error">{`Mật khẩu mới ${error.newPassword}`}</small>}
          </div>
          <div>
            <label htmlFor="confirmPassword" className="block text-900 font-medium mb-2">
              Xác nhận mật khẩu
              <span className="required">*</span>
            </label>
            <Password feedback={false} name="confirmPassword" toggleMask={true} id="confirmPassword" type="text" value={value.confirmPassword} onChange={(e) => handleChange(e)} />
            {error.confirmPassword && <small className="p-error">{` ${error.confirmPassword}`}</small>}
          </div>
        </div>
        <Button label="Lấy lại mật khẩu" className="w-full p-button-success" disabled={submitted} />

        <div className="text-center mt-3">
          <Link to="/login">
            <span className="font-medium no-underline ml-2 text-blue-500 text-right cursor-pointer">Quay lại đăng nhập</span>
          </Link>
        </div>
      </form>
    </>
  );
}
